import {useCallback, useContext} from 'react';

import ClinicPositionsSidebarLayout from '@/src/jobPortal/clinicPositions/components/ClinicPositionsSidebarLayout';
import ClinicPositionsFilterPopup from '@/src/jobPortal/clinicPositions/containers/ClinicPositionsFilterPopup';
import useClinicPositions from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import PopupContext from '@/src/popup/utils/PopupContext';

const ClinicPositionsSidebar = () => {
  const {filter, onClearClick} = useClinicPositions();
  const {openPopup} = useContext(PopupContext);

  const handleOpenMobileFilter = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <ClinicPositionsFilterPopup />,
      options: {withCloseButton: true, withTransparentBackground: true},
    });
  }, []);

  return (
    <ClinicPositionsSidebarLayout
      filter={filter}
      onMobileFilterClick={handleOpenMobileFilter}
      onClearClick={onClearClick}
    />
  );
};

export default ClinicPositionsSidebar;
